import WooCommerce from './woocommerce'
import WordPress from './wordpress'
import Stripe from './stripe'
import Payment from './payment'

const woo = new WooCommerce()

export { woo, Stripe, WordPress as wp, Payment }
